import { render, staticRenderFns } from "./ValveRecord.vue?vue&type=template&id=627c414e&scoped=true&"
import script from "./ValveRecord.vue?vue&type=script&lang=js&"
export * from "./ValveRecord.vue?vue&type=script&lang=js&"
import style0 from "./ValveRecord.vue?vue&type=style&index=0&id=627c414e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c414e",
  null
  
)

export default component.exports